module.exports = __webpack_public_path__ + "img/pt_br.a3f02654.svg";